import { render, staticRenderFns } from "./Pos_invoices_tax_refund_add.vue?vue&type=template&id=48af335d&scoped=true&"
import script from "./Pos_invoices_tax_refund_add.vue?vue&type=script&lang=js&"
export * from "./Pos_invoices_tax_refund_add.vue?vue&type=script&lang=js&"
import style0 from "./Pos_invoices_tax_refund_add.vue?vue&type=style&index=0&id=48af335d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48af335d",
  null
  
)

export default component.exports